import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Save } from "lucide-react";

export default function LoyaltyRules() {
  const [rules, setRules] = useState(null);
  const [msg, setMsg] = useState("");

  useEffect(() => { api.get("/loyalty/rules").then(r => setRules(r.data)); }, []);

  if (!rules) return <Layout title="Loyalty Rules"><div>Loading…</div></Layout>;

  const set = (k, v) => setRules({ ...rules, [k]: v });

  const save = async (e) => {
    e.preventDefault();
    const payload = { ...rules };
    delete payload.id;
    delete payload._id;
    Object.keys(payload).forEach(k => {
      if (typeof payload[k] === "string" && !isNaN(payload[k]) && k !== "bill_auto_approve") {
        payload[k] = parseFloat(payload[k]);
      }
    });
    const r = await api.put("/loyalty/rules", payload);
    setRules(r.data); setMsg("Saved."); setTimeout(() => setMsg(""), 2500);
  };

  return (
    <Layout title="Loyalty Rules" subtitle="Configuration"
      action={msg && <span className="text-[#4A6741] text-sm" data-testid="rules-saved">{msg}</span>}>
      <form onSubmit={save} className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className="card-sharp p-7">
          <div className="label-tiny">Earning</div>
          <div className="text-xl font-light mt-1 mb-5" style={{fontFamily:"Outfit"}}>Points & bills</div>

          <div className="space-y-5">
            <Field label="Points earned per ₹ spent" value={rules.points_per_rupee} onChange={(v) => set("points_per_rupee", v)} testId="rule-points-per-rupee" />
            <Field label="Minimum bill amount (₹)" value={rules.min_bill_amount} onChange={(v) => set("min_bill_amount", v)} testId="rule-min-bill" />
            <Field label="Welcome bonus points" value={rules.welcome_bonus_points} onChange={(v) => set("welcome_bonus_points", v)} testId="rule-welcome" />
            <Field label="Referral bonus points" value={rules.referral_bonus_points} onChange={(v) => set("referral_bonus_points", v)} testId="rule-referral" />

            <div className="flex items-center gap-3 pt-2">
              <input type="checkbox" id="auto" checked={!!rules.bill_auto_approve} onChange={(e) => set("bill_auto_approve", e.target.checked)} data-testid="rule-auto-approve" />
              <label htmlFor="auto" className="text-sm">Auto-approve bills (instant offer unlock)</label>
            </div>
          </div>
        </div>

        <div className="card-sharp p-7">
          <div className="label-tiny">Redemption & Tiers</div>
          <div className="text-xl font-light mt-1 mb-5" style={{fontFamily:"Outfit"}}>Customer ladder</div>

          <div className="space-y-5">
            <Field label="₹ value per redeemed point" value={rules.rupees_per_point_redeem} onChange={(v) => set("rupees_per_point_redeem", v)} testId="rule-redeem-rate" />
            <Field label="Silver tier (points)" value={rules.tier_silver} onChange={(v) => set("tier_silver", v)} testId="rule-tier-silver" />
            <Field label="Gold tier (points)" value={rules.tier_gold} onChange={(v) => set("tier_gold", v)} testId="rule-tier-gold" />
            <Field label="Platinum tier (points)" value={rules.tier_platinum} onChange={(v) => set("tier_platinum", v)} testId="rule-tier-platinum" />
          </div>
        </div>

        <div className="lg:col-span-2 flex justify-end">
          <button type="submit" className="btn-dark flex items-center gap-2" data-testid="save-rules-btn"><Save size={14} /> Save rules</button>
        </div>
      </form>
    </Layout>
  );
}

const Field = ({ label, value, onChange, testId }) => (
  <div>
    <div className="label-tiny mb-1.5">{label}</div>
    <input type="number" step="0.01" className="fin" value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testId} />
  </div>
);
